<div *ngIf="filterProps.isRight == isRight" [formGroup]="formGroup">
  <div *ngIf="filterProps.type == FilterType.TEXTBOX || filterProps.type == FilterType.TEXTBOXADVANCED" class="textbox">
    <div class="fullsize">
      <mat-form-field class="fullsize">
        <mat-label>{{filterProps.name | translate}}</mat-label>
        <input matInput type="text" formControlName="{{StatsGraphFilterKind[filterProps.kind]}}" [required]=filterProps.isRequired [minlength]=filterProps.min [maxlength]=filterProps.max (input)="getAutocompleteList(2, false, false)" [attr.list]="'autocmp-' + StatsGraphFilterKind[filterProps.kind]" autocomplete="off">
        <mat-error style="white-space: pre">{{getErrors(formGroup.controls[StatsGraphFilterKind[filterProps.kind]].errors).join('\n')}}</mat-error>
        <datalist [id]="'autocmp-' + StatsGraphFilterKind[filterProps.kind]">
          <select>
            <option *ngFor="let c of autocompleteList" value="{{c}}"></option>
          </select>
        </datalist>
      </mat-form-field>
    </div>
    &nbsp;&nbsp;
    <div *ngIf="filterProps.type == FilterType.TEXTBOXADVANCED">
      <mat-radio-group formControlName="{{StatsGraphFilterKind[filterProps.kind] + '-EXT'}}" class="textbox-advanced">
        <mat-radio-button [value]=0 [checked]="true">{{'search.began'|translate}}</mat-radio-button>
        <mat-radio-button [value]=1>{{'search.contains'|translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
  </div>

  <div *ngIf="filterProps.type == FilterType.CHECKBOX" class="checkbox">
    <mat-checkbox formControlName="{{StatsGraphFilterKind[filterProps.kind]}}">{{filterProps.name | translate}}</mat-checkbox>
  </div>

  <div *ngIf="filterProps.type == FilterType.NUMUPDOWN" class="numupdown">
    <div class="fullsize">
      <mat-form-field class="fullsize">
        <mat-label>{{filterProps.name | translate}}</mat-label>
        <input matInput type="number" formControlName="{{StatsGraphFilterKind[filterProps.kind]}}" [required]=filterProps.isRequired [min]=filterProps.min [max]=filterProps.max>
        <mat-error style="white-space: pre">{{getErrors(formGroup.controls[StatsGraphFilterKind[filterProps.kind]].errors).join('\n')}}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="filterProps.type == FilterType.DROPDOWN && dropdownOptions.length > 0" class="dropdown">
    <div class="fullsize">
      <span class="fullsize loading" *ngIf="isDropdownLoading">
        {{'stats.common.loading' | translate}}
      </span>
      <mat-form-field class="fullsize" *ngIf="!isDropdownLoading">
        <mat-label>{{filterProps.name | translate}}</mat-label>
        <mat-select formControlName="{{StatsGraphFilterKind[filterProps.kind]}}" [required]=filterProps.isRequired>
          <mat-option [value]=null></mat-option>
          <mat-option *ngFor="let option of dropdownOptions; index as idx" [value]=option.value>
            {{option.label | translate}}
          </mat-option>
        </mat-select>
        <mat-error style="white-space: pre">{{getErrors(formGroup.controls[StatsGraphFilterKind[filterProps.kind]].errors).join('\n')}}</mat-error>
      </mat-form-field>
    </div>
  </div>
</div>
